export default {
  "it-IT": {
    remove: {
      confirmation: "Confermi la rimozione della notifica?"
    }
  },
  "fr-FR": {
    remove: {
      confirmation: "Souhaitez-vous vraiment supprimer l'alerte ?"
    }
  },
  "es-ES": {
    remove: {
      confirmation: "¿Estás seguro de que deseas eliminar la alerta?"
    }
  },
  "en-GB": {
    remove: {
      confirmation: "Are you sure you want to delete the alert?"
    }
  },
  "en-US": {
    remove: {
      confirmation: "Are you sure you want to delete the alert?"
    }
  },
  "de-DE": {
    remove: {
      confirmation: "Bestätigen Sie die Abmeldung der Benachrichtigungen?"
    }
  },
  "en-AU": {
    remove: {
      confirmation: "Are you sure you want to delete the alert?"
    }
  },
  "ko-KR": {
      remove: {
          confirmation: "알림 서비스를 삭제하시겠습니까?"
      }
  }
};
